import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../theme";
import { useMemo } from "react";
import Text from "../../../../theme/text/Text";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const TimeLinePicking = (props) => {
    const theme = useTheme();
    const {t,i18n} = useTranslation();
    const colors = tokens(theme.palette.mode);
    
    return(
        <Box
            sx={{
                flex:1,
                "@media screen and (max-width: 47.9375em)" : {
                    display:"flex",
                    flexDirection:"column",
                }
            }}
        >
            <Box sx={{ mb:0.5 }}>
                <Box
                    sx={{
                        display:"flex",
                        justifyContent:"space-between",
                    }}
                >
                    <Text bold>{t("picking")}</Text>
                    <Box>
                        <Text>{new Date(props.createdAt).toLocaleDateString(i18n.language)}</Text>&nbsp;
                        <Text light>{new Date(props.createdAt).toLocaleTimeString(i18n.language, { hour: '2-digit', minute: '2-digit' })}</Text>
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    px:2,
                    display:"flex",
                    alignItems:'flex-start',
                    gap:1.5,
                    width:1,
                    borderRadius:4,
                    py:1.5,
                    background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100],
                    "@media screen and (max-width: 47.9375em)" : {
                        width:250,
                        flex:1,
                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[200],
                    }
                }}
            >
                <Box
                    sx={{
                        display:"flex",
                        alignItems:'center',
                        justifyContent:'center',
                        color:colors.txt["primary"],
                        borderRadius:4,
                        flexShrink:0,
                        height:32,
                        width:32,
                        background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[200],
                        "@media screen and (max-width: 47.9375em)" : {
                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                        }
                    }}
                >
                    {props.isRelation ? <InfoOutlinedIcon/> : <PersonOutlineOutlinedIcon/>}
                </Box>
                <Box>
                    <Text>{props.userName}</Text><br/>
                    {props.extraInfo && <><Text italic>{props.extraInfo}</Text><br/></>}
                    <Text light>{props.description}</Text>
                </Box>
            </Box>
        </Box>
    )
}

export default TimeLinePicking;